import src from "IMAGE";
export default { src, width: 740, height: 713, blurWidth: 0, blurHeight: 0};
